export default "__VITE_ASSET__Beh9ZaIX__"